import React, {
  useEffect,
  useMemo, useRef, useState
} from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';

import Confirmation from './Confirmation';

import Loading from 'components/atoms/Loading';
import Section from 'components/organisms/Section';
import { getAddOnPackagesService, getMainPackagesService } from 'services/servicePackages';
import { ServicePackageAddOnData } from 'services/servicePackages/type';

export interface PackageOption {
  id: number;
  name: string;
  amount: number;
  duration: number;
  description?: string;
  servicePackageAddOnData?: ServicePackageAddOnData[],
  numberOfAgent?: number,
  numberOfFile?: number,
  totalSizeLimit?: number,
  numberOfWebsite?: number,
  numberOfSession?: number;
  latestTier?: {
    numberOfAgent: number,
    numberOfFile: number,
    totalSizeLimit: number,
    numberOfWebsite: number,
    numberOfSession: number

  }
}

const RenewPackage: React.FC = () => {
  /* States */
  const [billingType, setBillingType] = useState<'one-time' | 'subscription'>('subscription');

  interface LocationState {
    planData?: {
      packageData?: any;
    };
    [key: string]: any;
  }

  const location = useLocation() as { state: LocationState };
  const recaptchaRef = useRef<ReCAPTCHA | null>(null);
  const { billingData, invoiceData } = location.state;

  const { data: mainPackagesData, isLoading: isMainLoading } = useQuery({
    queryKey: ['getMainPackages'],
    queryFn: getMainPackagesService,
  });

  const { data: addonPackagesData, isLoading: isAddonLoading } = useQuery({
    queryKey: ['getAddOnPackages'],
    queryFn: getAddOnPackagesService,
  });

  const mainPackages: PackageOption | undefined = useMemo(() => {
    if (!mainPackagesData) return undefined;
    return mainPackagesData.data
      .map((pkg) => {
        if (!pkg.servicePackageData || typeof pkg.servicePackageData.id === 'undefined') {
          return {} as PackageOption;
        }
        return {
          amount: pkg.servicePackageData.price || 0,
          servicePackageAddOnData: pkg.servicePackageData.servicePackageAddOnData,
          ...pkg?.servicePackageData
        };
      }).find(
        (item) => item.name === billingData?.planData?.packageName
          && item.duration === billingData?.planData?.duration
      );
  }, [billingData?.planData?.duration, billingData?.planData?.packageName, mainPackagesData]);

  const AddOnPackages: PackageOption | undefined = useMemo(() => {
    if (!addonPackagesData) return undefined;
    return addonPackagesData.data
      .map((pkg) => {
        if (!pkg.servicePackageAddOnData || typeof pkg.servicePackageAddOnData.id === 'undefined') {
          return {} as PackageOption;
        }
        return {
          amount: pkg.servicePackageAddOnData.price || 0,
          ...pkg?.servicePackageAddOnData
        };
      }).find(
        (item) => item.name === billingData?.planData?.packageName
          && item.duration === billingData?.planData?.duration
      );
  }, [addonPackagesData, billingData?.planData?.duration, billingData?.planData?.packageName]);

  useEffect(() => {
    setBillingType(billingData?.planData === 1 ? 'one-time' : 'subscription');
  }, [billingData]);

  return isMainLoading || isAddonLoading ? <div className="p-checkout_paymentStatus_loading"><Loading /></div> : (
    <Section>
      <div className="p-checkout">

        <div className="p-checkout_content p-addNewPackage_mt32">
          <Confirmation
            billingType={billingType}
            invoiceData={invoiceData}
            total={mainPackages?.amount || AddOnPackages?.amount || 0}
            mainPackages={mainPackages || AddOnPackages}
            billingData={billingData}
            isAddOn={!!AddOnPackages}
          />
        </div>
        <ReCAPTCHA ref={recaptchaRef} sitekey="6Lcp4MIZAAAAABHdGwULZhEv01tu2iODEDzSterA" size="invisible" />
      </div>
    </Section>
  );
};

export default RenewPackage;
